/**
 * sRGB → linear, for mesh export. Pure, so it is testable without a GPU.
 *
 * Deliberately hand-rolled rather than routed through `THREE.Color`: since r152
 * three's colour management already decodes a hex string into the working
 * (linear) space, so borrowing it here would be a **second** conversion on
 * values that go straight into glTF `baseColorFactor`. The result of that
 * mistake is a model that imports looking washed out — plausible enough that
 * people blame the importer.
 */

/** "#rrggbb" → three floats in 0..1, still sRGB-encoded. */
export function hexToRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
}

/** The exact sRGB transfer function — not the 2.2 gamma approximation. */
export const srgbToLinear = (c) =>
  c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);

/** "#rrggbb" → linear float triple, what glTF material factors want. */
export const hexToLinear = (hex) => hexToRgb(hex).map(srgbToLinear);
